module.exports = __webpack_public_path__ + "static/media/pulverisateur.1040ffcb.jpg";